import { effect as _$effect } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { use as _$use } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { theme } from "../theme";
export function Sidebar(props) {
  let selectRef;
  return (() => {
    var _el$ = _$createElement("box"),
      _el$2 = _$createElement("select");
    _$insertNode(_el$, _el$2);
    _$setProp(_el$, "width", 30);
    _$setProp(_el$, "border", true);
    _$use(r => selectRef = r, _el$2);
    _$setProp(_el$2, "onChange", index => {
      props.store.setSelectedTableIndex(index);
    });
    _$setProp(_el$2, "showScrollIndicator", true);
    _$setProp(_el$2, "wrapSelection", true);
    _$setProp(_el$2, "style", {
      width: "100%",
      height: "100%"
    });
    _$effect(_p$ => {
      var _v$ = props.focused ? theme.colors.borderActive : theme.colors.border,
        _v$2 = {
          backgroundColor: theme.colors.background,
          flexDirection: "column"
        },
        _v$3 = props.focused,
        _v$4 = props.store.tables().map((t, i) => ({
          name: t.name,
          description: "",
          value: i
        })),
        _v$5 = props.onSelect,
        _v$6 = theme.colors.selected,
        _v$7 = theme.colors.textBright;
      _v$ !== _p$.e && (_p$.e = _$setProp(_el$, "borderColor", _v$, _p$.e));
      _v$2 !== _p$.t && (_p$.t = _$setProp(_el$, "style", _v$2, _p$.t));
      _v$3 !== _p$.a && (_p$.a = _$setProp(_el$2, "focused", _v$3, _p$.a));
      _v$4 !== _p$.o && (_p$.o = _$setProp(_el$2, "options", _v$4, _p$.o));
      _v$5 !== _p$.i && (_p$.i = _$setProp(_el$2, "onSelect", _v$5, _p$.i));
      _v$6 !== _p$.n && (_p$.n = _$setProp(_el$2, "selectedBackgroundColor", _v$6, _p$.n));
      _v$7 !== _p$.s && (_p$.s = _$setProp(_el$2, "selectedTextColor", _v$7, _p$.s));
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined,
      o: undefined,
      i: undefined,
      n: undefined,
      s: undefined
    });
    return _el$;
  })();
}